import React, { useCallback } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import * as actions from '../../actions';
import Countdown from 'react-countdown';
import App from '../../App';
import cookie from 'react-cookies';
import { URL } from '../../constants';

const TopNav = props => {
    const dispatch = useDispatch();
    const logout = useCallback(() => dispatch(actions.logout()), [dispatch]);
    const userJson = sessionStorage.getItem('user');
    const user = userJson === null? {account:'', role : {groupName : '', }, userDetail : {name: ''}} : JSON.parse(userJson).user;
    
    const perfomLogout = () => {  	
        //清除cookies
        cookie.remove('X-OCA-Token');
        cookie.remove('RequestAccount');
        cookie.remove('RequestFunctionNo');
        cookie.remove('captchaID');
        logout();
        callLogout();
    }
    
    const callLogout = async () => {
        const finalData = {
            account: user.account
        };
        const response = await fetch(`${URL}/user/logout`, {
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            method: 'POST',
            body: JSON.stringify(finalData)
        }).then(res => res.json());
    };
    
    const renderer = ({ minutes, seconds, completed }) => {
    	return <span> {minutes}:{seconds}</span>;
    };

    const topNavOptions = (
        <div className="nav-right" style={{bottom: '2px'}}>
            <div className="other-menu" style={{marginBottom: '3px'}}>
                <ul>
                    <li><Link to="/">首頁</Link><span>|</span></li>
                    <li><Link to="/OperationManual">操作手冊</Link><span>|</span></li>
                    <li><a href="#!" data-toggle="modal" data-target="#videoBox">教學影片</a><span>|</span></li>
                    <li><NavLink to="/PersonDataMaintain">個人資料維護</NavLink></li>
                </ul>
            </div>            
            <div className="modal" id="videoBox" role="dialog" aria-hidden="true">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="modal-title">系統教學影片</div>
                            <div>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <img src={`${process.env.PUBLIC_URL}/images/btn_close.svg`} width="40" height="40" />
                                </button>
                            </div>
                        </div>
                        <div className="modal-body oac-video-list">
                            <div className="row">
                                <div className="col-md-3 col-xs-6">
                                    <a href="#!" id="a01">
                                        <img src="https://img.youtube.com/vi/5hu6arAtwJM/hqdefault.jpg" alt="簽審文件申請" />
                                        <div className="video-list-bg">
                                            <p>簽審文件申請</p>
                                        </div>
                                    </a>
                                </div>
                                <div className="col-md-3 col-xs-6">
                                    <a href="#!" id="a02">
                                        <img src="https://img.youtube.com/vi/dA4H6fCCmAQ/hqdefault.jpg" alt="申辦案件狀態查詢" />
                                        <div className="video-list-bg">
                                            <p>申辦案件狀態查詢</p>
                                        </div>
                                    </a>
                                </div>
                                <div className="col-md-3 col-xs-6">
                                    <a href="#!" id="a03">
                                        <img src="https://img.youtube.com/vi/FcL5dU81xaA/hqdefault.jpg" alt="核准證書查詢與異動" />
                                        <div className="video-list-bg">
                                            <p>核准證書查詢與異動</p>
                                        </div>
                                    </a>
                                </div>
                                <div className="col-md-3 col-xs-6">
                                    <a href="#!" id="a04">
                                        <img src="https://img.youtube.com/vi/CKLdT_rELc4/hqdefault.jpg" alt="新增物種申請" />
                                        <div className="video-list-bg">
                                            <p>新增物種申請</p>
                                        </div>
                                    </a>
                                </div>
                            </div>
                            <div className="btn-box">
                                <button type="button" className="btn btn-success" alt="關閉" data-dismiss="modal">關閉</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal" id="video" role="dialog" aria-labelledby="exampleModalScrollableLabel"
                aria-hidden="true">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div id="modalTitle" className="modal-title"></div>
                            <div>
                                <button type="button" className="close stopVideo01" data-dismiss="modal" aria-label="Close">
                                    <img src={`${process.env.PUBLIC_URL}/images/btn_close.svg`} width="40" height="40" />
                                </button>
                                <button type="button" className="close stopVideo02" data-dismiss="modal" aria-label="Close">
                                    <img src={`${process.env.PUBLIC_URL}/images/btn_close.svg`} width="40" height="40" />
                                </button>
                                <button type="button" className="close stopVideo03" data-dismiss="modal" aria-label="Close">
                                    <img src={`${process.env.PUBLIC_URL}/images/btn_close.svg`} width="40" height="40" />
                                </button>
                                <button type="button" className="close stopVideo04" data-dismiss="modal" aria-label="Close">
                                    <img src={`${process.env.PUBLIC_URL}/images/btn_close.svg`} width="40" height="40" />
                                </button>
                            </div>
                        </div>
                        <div className="modal-body oac-video-list">
                            <div className="row" id="oac-video-content">
                                <div className="col-md-12 oac-video-content">
                                    <div className="videobox">
                                        <div className="ocaPlayer" id="ocaPlayer01"></div>
                                        <div className="ocaPlayer" id="ocaPlayer02"></div>
                                        <div className="ocaPlayer" id="ocaPlayer03"></div>
                                        <div className="ocaPlayer" id="ocaPlayer04"></div>
                                    </div>
                                </div>
                            </div>
                            <div className="btn-box">
                                <button type="button" className="btn btn-success stopVideo01" alt="關閉" data-dismiss="modal">關閉</button>
                                <button type="button" className="btn btn-success stopVideo02" alt="關閉" data-dismiss="modal">關閉</button>
                                <button type="button" className="btn btn-success stopVideo03" alt="關閉" data-dismiss="modal">關閉</button>
                                <button type="button" className="btn btn-success stopVideo04" alt="關閉" data-dismiss="modal">關閉</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="nav-content">
                <p className="nav-user"><img src="../images/user_icon.png" alt="系統使用者" /> {user.account} {user.userDetail.name} {user.role.groupName}</p>
                <p className="timeout">
                	<img src="../images/time_icon.png" alt="系統登出時間" /> <span>系統登出時間</span> 
                	<Countdown date={Date.now() + (30 * 60 * 1000)} 
                        renderer={renderer}
                        onComplete={() => perfomLogout()}></Countdown>
                </p>
                <div className="nav-btn" style={{top: '15px'}}>
                    <a href="/#" onClick={perfomLogout}><img src="../images/btn_02.png" alt="系統登出" /></a>
                </div>
                <button title="主選單" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar-main">
                    <span className="icon-bar"></span>
                    <span className="icon-bar"></span>
                    <span className="icon-bar"></span>
                </button>
            </div>
        </div>
    );

    return (
        <nav className="nav-box">
            <div className="nav-left">
                <div className="logo"><img src="../images/logo.png" alt="海洋委員會海洋保育署-海洋野生動物簽審通關作業平台" /></div>
            </div>

            {props.showOptions && topNavOptions}

        </nav>
    );
}

export default TopNav;